module.exports = __webpack_public_path__ + "static/media/预约-散客.2b6ed983.svg";